import SFetch from '@app/utils/sfetch'
import { LeftDrawerCacheService } from '@app/shared/services/left-drawer-cache'
import { getSignal } from '@app/adapters/abort'

import type { LeftDrawerWorkflow } from '../types'

export async function getCompanyWorkflows(): Promise<
  LeftDrawerWorkflow[] | null
> {
  const url = `/f/${window.Silverfin.currentFirmId}/${window.Silverfin.currentCompanyId}/workflows/list`
  const cacheKey = LeftDrawerCacheService.buildCacheKey({
    currentFirmId: window.Silverfin.currentFirmId,
    currentCompanyId: window.Silverfin.currentCompanyId,
  })
  const signal = getSignal('leftDrawer')

  try {
    return await LeftDrawerCacheService.getOrFetch<LeftDrawerWorkflow[]>(
      'workflows',
      cacheKey,
      async () =>
        (await SFetch.json<LeftDrawerWorkflow[]>(url, { signal })) ?? null
    )
  } catch {
    return null
  }
}
